const pageStyle = {
  background: '#071016',
  color: '#f6f1bd',
  bottom: 0,
  boxSizing: 'border-box',
  left: 0,
  overflowY: 'auto',
  padding: '48px 24px 72px',
  position: 'absolute',
  right: 0,
  top: 0,
  zIndex: 1,
}

const contentStyle = {
  fontFamily: 'Luckiest Guy, sans-serif',
  lineHeight: 1.65,
  margin: '0 auto',
  maxWidth: '760px',
}

const headingStyle = {
  color: '#f5e85a',
  fontFamily: 'Luckiest Guy, sans-serif',
  fontWeight: 400,
  letterSpacing: '0.04em',
}

export default function PrivacyPolicy() {
  return (
    <main style={pageStyle}>
      <article style={contentStyle}>
        <p style={{ color: '#9edb70', fontSize: '0.9rem', margin: 0 }}>YUT GAME</p>
        <h1 style={{ ...headingStyle, fontSize: '2.4rem', margin: '8px 0 0' }}>Privacy Policy</h1>
        <p style={{ color: '#c8c59d', marginTop: 0 }}>Effective date: September 7, 2026</p>

        <p>
          Yut Game (&quot;we,&quot; &quot;us,&quot; or &quot;our&quot;) provides an online multiplayer Yutnori game through our website and mobile application. This Privacy Policy explains how we collect, use, and protect information when you use Yut Game.
        </p>

        <h2 style={headingStyle}>Information We Collect</h2>
        <p>We may collect information needed to operate online multiplayer games, including:</p>
        <ul>
          <li>A display name or player name you provide</li>
          <li>Game room information, game settings, scores, moves, and match results</li>
          <li>Technical information such as IP address, device type, browser or app version, and connection logs</li>
          <li>Messages or information you send when contacting us for support</li>
        </ul>
        <p>Yut Game does not require players to provide sensitive personal information to play.</p>

        <h2 style={headingStyle}>How We Use Information</h2>
        <p>We use information to create and manage multiplayer rooms, synchronize game state between players, apply selected custom rules, maintain security, troubleshoot issues, improve Yut Game, and respond to support requests.</p>

        <h2 style={headingStyle}>Sharing Information</h2>
        <p>We do not sell personal information. We may share limited information with service providers that help us host and operate Yut Game, such as cloud hosting, database, and network providers. These providers may only use information as needed to provide their services to us.</p>
        <p>We may also disclose information when required by law or when necessary to protect the security, rights, and safety of Yut Game, players, or others.</p>

        <h2 style={headingStyle}>Game Information Visibility</h2>
        <p>Player display names, room settings, moves, scores, and match outcomes can be visible to other players in the same multiplayer room. Do not use your real name, contact information, or other sensitive personal information as your display name.</p>

        <h2 style={headingStyle}>Data Retention</h2>
        <p>We keep information only as long as needed to operate Yut Game, maintain security, resolve disputes, meet legal obligations, or improve the service. Temporary multiplayer game data may be deleted after a game or room ends.</p>

        <h2 style={headingStyle}>Children&apos;s Privacy</h2>
        <p>Yut Game is not directed to children under 13, and we do not knowingly collect personal information from children under 13. If you believe a child has provided us personal information, contact us so we can delete it.</p>

        <h2 style={headingStyle}>Security</h2>
        <p>We use reasonable administrative and technical measures to protect information. However, no online service can guarantee absolute security.</p>

        <h2 style={headingStyle}>Your Choices and Requests</h2>
        <p>You may request access to, correction of, or deletion of personal information we hold about you by contacting us. Some information may need to be retained for legal, security, or operational reasons.</p>

        <h2 style={headingStyle}>International Use</h2>
        <p>Yut Game may be accessed from different countries. Information may be processed in countries where our service providers operate, which may have privacy laws different from those in your country.</p>

        <h2 style={headingStyle}>Changes to This Policy</h2>
        <p>We may update this Privacy Policy from time to time. We will post the updated version on this page and revise the effective date above.</p>

        <h2 style={headingStyle}>Contact Us</h2>
        <p>
          For privacy questions or requests, email <a href="mailto:beatrhino@gmail.com" style={{ color: '#9edb70' }}>beatrhino@gmail.com</a> or visit our <a href="https://discord.gg/RwbTfezXu7" target="_blank" rel="noreferrer" style={{ color: '#9edb70' }}>Discord community</a>.
        </p>
      </article>
    </main>
  )
}